__turbopack_context__.v({
  "active": "NavQuickLinksVertical-module-scss-module__nMZcvq__active",
  "afterStep": "NavQuickLinksVertical-module-scss-module__nMZcvq__afterStep",
  "step": "NavQuickLinksVertical-module-scss-module__nMZcvq__step",
  "stepContainer": "NavQuickLinksVertical-module-scss-module__nMZcvq__stepContainer",
  "stepContent": "NavQuickLinksVertical-module-scss-module__nMZcvq__stepContent",
  "stepLabel": "NavQuickLinksVertical-module-scss-module__nMZcvq__stepLabel",
  "stepLine": "NavQuickLinksVertical-module-scss-module__nMZcvq__stepLine",
  "verticalStepper": "NavQuickLinksVertical-module-scss-module__nMZcvq__verticalStepper",
});
